module.exports = __webpack_public_path__ + "static/media/chanel-allure-big.8feaa3d2.png";